const sendEmail = async (to, subject, htmlContent) => {
    try {
        const response = await fetch('http://localhost:3000/api/send-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ to, subject, html: htmlContent }),
        });

        if (response.ok) {
            console.log('Email sent successfully');
            return true;
        } else {
            const errorDetails = await response.json();
            console.error('Failed to send email:', errorDetails);
            return false;
        }
    } catch (error) {
        console.error('Error occurred while sending email:', error);
        return false;
    }
};

// Function for welcome email (SignUp)
export const sendWelcomeEmailArtistReseller = async (username, isd, mobile, toEmail, password) => {
    const subject = 'Welcome to IndiGalleria – Your Registration is Complete!';
    const htmlContent = `
        <html>
        <body style="font-family: Arial, sans-serif; line-height: 1.6; padding: 20px;">
            <table style="width: 100%; max-width: 600px; margin: auto; border: 1px solid #ddd; border-radius: 5px; overflow: hidden;">
                <tr>
                    <td style="background-color: #f2f2f2; padding: 20px;">
                        <h2 style="text-align: center; color: #333;">Welcome to IndiGalleria!</h2>
                    </td>
                </tr>
                <tr>
                    <td style="padding: 20px;">
                        <p><b>Dear ${username},</b></p>
                        <p>Thank you for registering with <b>IndiGalleria!</b> We’re excited to have you join our community.</p>
                        <p>Here’s a summary of your registration:</p>
                        <ul>
                            <li><strong>Username:</strong> ${toEmail} or ${mobile}</li>
                            <li><strong>Password:</strong> ${password}</li>
                        </ul>
                        <p>You can now log in to your account and start exploring our extensive collection of artworks. If you have any questions or need assistance, please don’t hesitate to reach out to our support team at info@indigalleria.com.</p>
                        <p>Welcome aboard!</p>
                        <p>Best regards,<br> 
                            The IndiGalleria Team<br>
                            <a href="https://www.indigalleria.com">https://www.indigalleria.com</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="background-color: #f2f2f2; padding: 10px; text-align: center;">
                        <p style="font-size: 12px; color: #777;">&copy; 2017 - ${new Date().getFullYear()} IndiGalleria. All rights reserved.</p>
                    </td>
                </tr>
            </table>
        </body>
        </html>
    `;
    return await sendEmail(toEmail, subject, htmlContent);
};

// Function for welcome email (SignUp)
export const sendWelcomeEmailBuyer = async (username, isd, mobile, toEmail) => {
    const subject = 'Welcome to IndiGalleria – Your Registration is Complete!';
    const htmlContent = `
        <html>
        <body style="font-family: Arial, sans-serif; line-height: 1.6; padding: 20px;">
            <table style="width: 100%; max-width: 600px; margin: auto; border: 1px solid #ddd; border-radius: 5px; overflow: hidden;">
                <tr>
                    <td style="background-color: #f2f2f2; padding: 20px;">
                        <h2 style="text-align: center; color: #333;">Welcome to IndiGalleria!</h2>
                    </td>
                </tr>
                <tr>
                    <td style="padding: 20px;">
                        <p><b>Dear ${username},</b></p>
                        <p>Thank you for registering with <b>IndiGalleria!</b> We’re excited to have you join our community.</p>
                        <p>Here’s a summary of your registration:</p>
                        <ul>
                            <li><strong>Registered Name :</strong> ${username}</li>
                            <li><strong>Registered Email :</strong> ${toEmail}</li>
                            <li><strong>Registered Mobile No :</strong> ${mobile}</li>
                        </ul>
                        <p>You can now log in to your account and start exploring our extensive collection of artworks. If you have any questions or need assistance, please don’t hesitate to reach out to our support team at info@indigalleria.com.</p>
                        <p>Welcome aboard!</p>
                        <p>Best regards,<br> 
                            The IndiGalleria Team<br>
                            <a href="https://www.indigalleria.com">https://www.indigalleria.com</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="background-color: #f2f2f2; padding: 10px; text-align: center;">
                        <p style="font-size: 12px; color: #777;">&copy; 2017 - ${new Date().getFullYear()} IndiGalleria. All rights reserved.</p>
                    </td>
                </tr>
            </table>
        </body>
        </html>
    `;
    return await sendEmail(toEmail, subject, htmlContent);
};

// Function for price request email
export const sendPriceRequestEmail = async (username, isd, mobile, toEmail, id, pdTitle, requestDetails) => {
    const subject = 'New Price Request has been received!';
    const htmlContent = `
        <html>
        <body style="font-family: Arial, sans-serif; line-height: 1.6; padding: 20px;">
            <table style="width: 100%; max-width: 600px; margin: auto; border: 1px solid #ddd; border-radius: 5px; overflow: hidden;">
                <tr>
                    <td style="padding: 20px;">
                        <p><b>Visitor : ${username},</b></p>
                        <p>Email : ${toEmail}</p>
                        <p>Mobile : ${isd}-${mobile}</p>
                        <p>Artwork : ${pdTitle} (${id})</p>
                        <p>Message : ${requestDetails}</p>
                    </td>
                </tr>
                <tr>
                    <td style="background-color: #f2f2f2; padding: 10px; text-align: center;">
                        <p style="font-size: 12px; color: #777;">&copy; 2017 - ${new Date().getFullYear()} IndiGalleria. All rights reserved.</p>
                    </td>
                </tr>
            </table>
        </body>
        </html>
    `;
    return await sendEmail('info@heuristticminds.com', subject, htmlContent);
};

// Function for Contact Us email
export const contactUsEmail = async (username, isd, mobile, toEmail, requestDetails) => {
    const subject = 'New Visitor`s Enquiry !';
    const htmlContent = `
        <html>
        <body style="font-family: Arial, sans-serif; line-height: 1.6; padding: 20px;">
            <table style="width: 100%; max-width: 600px; margin: auto; border: 1px solid #ddd; border-radius: 5px; overflow: hidden;">
                <tr>
                    <td style="padding: 20px;">
                        <p><b>Visitor : ${username},</b></p>
                        <p>Email : ${toEmail}</p>
                        <p>Mobile : ${isd}-${mobile}</p>
                        <p>Message : ${requestDetails}</p>
                    </td>
                </tr>
                <tr>
                    <td style="background-color: #f2f2f2; padding: 10px; text-align: center;">
                        <p style="font-size: 12px; color: #777;">&copy; 2017 - ${new Date().getFullYear()} IndiGalleria. All rights reserved.</p>
                    </td>
                </tr>
            </table>
        </body>
        </html>
    `;
    return await sendEmail('info@heuristticminds.com', subject, htmlContent);
};

// Function for price request email
export const sendSubscriptionRequestEmail = async (toEmail) => {
    const subject = 'Thanks for Subscribing with Indigalleria!';
    const htmlContent = `
        <html>
        <body style="font-family: Arial, sans-serif; line-height: 1.6; padding: 20px;">
            <table style="width: 100%; max-width: 600px; margin: auto; border: 1px solid #ddd; border-radius: 5px; overflow: hidden;">
                <tr>
                    <td style="padding: 20px;">
                        <p><b>Visitor : ${toEmail},</b></p>
                        <p>'Welcome to <b>Indigalleria</b>, Thanks for Subscribing with us. '</p>
                        <p>You will get updated on Exhibitions, Events, Promotions and More!</p>
                    </td>
                </tr>
                <tr>
                    <td style="background-color: #f2f2f2; padding: 10px; text-align: center;">
                        <p style="font-size: 12px; color: #777;">&copy; 2017 - ${new Date().getFullYear()} IndiGalleria. All rights reserved.</p>
                    </td>
                </tr>
            </table>
        </body>
        </html>
    `;
    return await sendEmail(toEmail, subject, htmlContent);
};

// Function to Send Payment Initiation Mail

export const sendPaymentSuccessEmail = async (username, toEmail, orderID) => {

    // Fetch order details by orderID
    let orderDetails = [];
    try {
        const orderResponse = await fetch(`https://igapi.heuristticminds.com/api/OrderList/Get-GetOrderProductDetailsByOrderID?order_ID=${orderID}`);
        orderDetails = await orderResponse.json();

        if (!orderDetails || orderDetails.length === 0) {
            console.error('No order details found for the provided order ID.');
            return false;
        }
    } catch (error) {
        console.error('Error fetching order details:', error);
        return false;
    }

    // Calculate total GST price
    const totalGSTPrice = orderDetails.reduce((total, item) => total + (item.gstPrice || 0), 0);

    // Construct the order details table
    const orderDetailsTable = orderDetails
        .map(
            (item) => `
            <tr>
                <td style="border: 1px solid #ddd; padding: 8px;">
                    <img src="${item.productImage}" alt="${item.productName}" style="width: 50px; height: auto;" />
                </td>
                <td style="border: 1px solid #ddd; padding: 8px;">
                    ${item.productName} <br />
                    Category: ${item.categoryType} <br />
                    Size: ${item.size} <br />
                    Artist: ${item.artistName} <br />
                    MRP: ${item.mrp} ${item.discRate > 0 ? `(${item.discRate}% OFF)` : ""}
                </td>
                <td style="border: 1px solid #ddd; padding: 8px;">${item.gstPrice}</td>
            </tr>
        `
        )
        .join('');
        
        // Add footer row for total GST price
        const orderDetailsFooter = `
        <tr>
            <td colspan="2" style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold;">Total GST Price:</td>
            <td style="border: 1px solid #ddd; padding: 8px; font-weight: bold;">${totalGSTPrice.toFixed(2)}</td>
        </tr>
        `;
    
    const subject = 'IndiGalleria - Order Update: Payment Initiation';
    const htmlContent = `
        <html>
        <body style="font-family: Arial, sans-serif; line-height: 1.6; padding: 20px;">
            <table style="width: 100%; max-width: 600px; margin: auto; border: 1px solid #ddd; border-radius: 5px; overflow: hidden;">
                <tr>
                    <td style="padding: 20px;">
                        <p><b>Dear ${username},</b></p>
                        <p>Thank you for initiating your payment for your IndiGalleria order!</p>
                        <p>This is an automated email to confirm we received your payment request. <span style="color: red;">Please note that it may take 2-3 business days for our bank to process the payment.</span></p>
                        <p>Once your payment is confirmed, you'll receive a separate "Order Authorization" email with complete details about your order and confirmation of payment received.</p>
                        <p>We appreciate your business and look forward to processing your order soon.</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p><b>Your Order Details</b></p>
                        <table style="width: 100%; border-collapse: collapse;">
                            <tr>
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Image</th>
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Artwork Detail</th>
                                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Amount (Including GST)</th>
                            </tr>
                            ${orderDetailsTable}
                            ${orderDetailsFooter}
                        </table>
                    </td>
                    </br>
                </tr>

                <tr>
                    <td>
                        <p>Thank you for your order! We appreciate your business and are committed to providing you with a seamless shopping experience and breathtaking original artwork at exceptional prices.</p>
                        <p>Do you have any questions or suggestions? We value your feedback and are always happy to help. Feel free to contact us at info@indigallera.com.</p>
                        <p>Connecting Art and Art Lovers Worldwide!</p>
                        <p>The IndiGalleria Team</p>
                        <p>www.indigalleria.com </p>
                    </td>
                    
                </tr>
                <tr>
                    <td style="background-color: #f2f2f2; padding: 10px; text-align: center;">
                        <p style="font-size: 12px; color: #777;">&copy; 2017 - ${new Date().getFullYear()} IndiGalleria. All rights reserved.</p>
                    </td>
                </tr>
            </table>
        </body>
        </html>
    `;
    return await sendEmail(toEmail, subject, htmlContent);
};